webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(298);


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularResource = __webpack_require__(371);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularCookie = __webpack_require__(373);
	
	var _angularCookie2 = _interopRequireDefault(_angularCookie);
	
	var _components = __webpack_require__(375);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _app = __webpack_require__(424);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(431);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('app', [_angularUiRouter2.default, _components2.default, _angularResource2.default, _angularCookie2.default]).config(["$locationProvider", function ($locationProvider) {
	  "ngInject";
	  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
	  // #how-to-configure-your-server-to-work-with-html5mode
	
	  $locationProvider.html5Mode(false).hashPrefix('');
	}]).component('app', _app2.default);

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _memo = __webpack_require__(376);
	
	var _memo2 = _interopRequireDefault(_memo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var componentModule = _angular2.default.module('app.components', [_memo2.default]).name;
	
	exports.default = componentModule;

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(299);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(301);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _memoComponent = __webpack_require__(377);
	
	var _memoComponent2 = _interopRequireDefault(_memoComponent);
	
	var _wordFactory = __webpack_require__(422);
	
	var _wordFactory2 = _interopRequireDefault(_wordFactory);
	
	var _gameResultFactory = __webpack_require__(423);
	
	var _gameResultFactory2 = _interopRequireDefault(_gameResultFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var memoModule = _angular2.default.module('memo', [_angularUiRouter2.default]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	  "ngInject";
	
	  $urlRouterProvider.otherwise('/');
	
	  $stateProvider.state('memo', {
	    url: '/',
	    component: 'memo'
	  });
	}]).component('memo', _memoComponent2.default).factory('Word', _wordFactory2.default).factory('GameResult', _gameResultFactory2.default).name;
	
	exports.default = memoModule;

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _memo = __webpack_require__(378);
	
	var _memo2 = _interopRequireDefault(_memo);
	
	var _memoController = __webpack_require__(379);
	
	var _memoController2 = _interopRequireDefault(_memoController);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var memoComponent = {
	  restrict: 'E',
	  bindings: {},
	  template: _memo2.default,
	  controller: _memoController2.default
	};
	
	exports.default = memoComponent;

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-md-12 clearfix\">\n        <h3 class=\"pull-left\">Poziom: {{$ctrl.currentLevel+1}} / {{$ctrl.levels.length}}</h3>\n        <div class=\"time pull-left\">Czas: {{$ctrl.timer / 100}}</div> <div class=\"unit\">sekund</div>\n    </div>\n    <div class=\"col-md-12\" ng-hide=\"$ctrl.startGame || $ctrl.gameOver\">\n        <strong>Powtórz słówka, a następnie rozpocznij grę:</strong>\n        <table class=\"table table-striped\">\n            <tr ng-repeat=\"word in $ctrl.learn\">\n                <td>{{word.word}}</td>\n                <td>{{word.translation}}</td>\n                <td>\n                    <audio id=\"player_{{word.id}}\" ng-src=\"files/mp3/{{word.id}}/{{word.id}}.mp3\"></audio>\n                    <span class=\"btn btn-sm btn-default glyphicon glyphicon-play\" ng-click=\"$ctrl.play(word.id)\" id=\"play_{{word.id}}\"></span>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class=\"clearfix\" ng-hide=\"$ctrl.startGame || $ctrl.gameOver\">\n    <div ng-show=\"$ctrl.showStartGameButton\">\n        <button class=\"btn btn-primary\" ng-click=\"$ctrl.start()\">\n            Rozpocznij grę <i class=\"glyphicon glyphicon-play\"></i>\n        </button>\n    </div>\n</div>\n\n\n<span ng-show=\"$ctrl.wordsLoading\">Trwa ładowanie danych...</span>\n<div class=\"clearfix\" ng-repeat=\"line in $ctrl.words\" ng-show=\"$ctrl.startGame\">\n    <div class=\"card\" ng-repeat=\"card in line\"\n         ng-class=\"{correct : $ctrl.checkIfCorrect($parent.$index, $index)}\">\n        <a class=\"cover\" ng-hide=\"$ctrl.checkIfVisible($parent.$index, $index) || $ctrl.checkIfCorrect($parent.$index, $index)\"\n           ng-click=\"$ctrl.showCard($parent.$index, $index)\"></a>\n        <a ng-show=\"$ctrl.checkIfVisible($parent.$index, $index) || $ctrl.checkIfCorrect($parent.$index, $index)\">{{card.word}}</a>\n    </div>\n</div>\n\n\n<div ng-show=\"$ctrl.gameOver\">\n    <div>Brawo! Ukończono poziom {{$ctrl.currentLevel + 1}}.!</div>\n    <br />\n    <div class=\"clearfix\">\n        <button ng-click=\"$ctrl.nextLevel()\" class=\"btn btn-success\" ng-hide=\"($ctrl.currentLevel+1) >= $ctrl.levels.length\">\n            Następny poziom <i class=\"glyphicon glyphicon-hand-right\"></i>\n        </button>\n        <button ng-click=\"$ctrl.saveResult()\" class=\"btn btn-danger\" ng-show=\"($ctrl.currentLevel+1) >= $ctrl.levels.length && !$ctrl.isResultSaved\">\n            Zapisz wynik  <i class=\"glyphicon glyphicon-save\"></i>\n        </button>\n        <span ng-show=\"$ctrl.isResultSaved\">Wynik został zapisany</span>\n    </div>\n    <br />\n    <div class=\"clearfix\">\n        <button ng-click=\"$ctrl.restartGame()\" class=\"btn btn-warning\">\n            Zagraj jeszcze raz od początku <i class=\"glyphicon glyphicon-refresh\"></i>\n        </button>\n    </div>\n</div>"

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(380);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(417);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(418);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MemoController = function () {
	  MemoController.$inject = ["Word", "GameResult", "$interval", "ipCookie"];
	  function MemoController(Word, GameResult, $interval, ipCookie) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MemoController);
	    (0, _assign2.default)(this, {
	      Word: Word,
	      GameResult: GameResult,
	      $interval: $interval,
	      ipCookie: ipCookie
	    });
	    this.words = [];
	    this.wordsLoading = false;
	
	    this.currentLevel = 0;
	    this.levels = [[2, 2], [2, 3], [2, 4], [2, 5], [3, 4], [4, 4], [4, 5]];
	
	    this.rows = this.levels[this.currentLevel][0];
	    this.cols = this.levels[this.currentLevel][1];
	
	    this.timer = 0;
	    this.timerPromise = null;
	    this.startGame = false;
	    this.gameOver = false;
	    this.words = [];
	    this.learn = [];
	    this.visibleCards = [];
	    this.tempVisibleCards = [];
	    this.correctCards = [];
	    this.showStartGameButton = false;
	    this.isResultSaved = false;
	
	    this.loadWords();
	  }
	
	  (0, _createClass3.default)(MemoController, [{
	    key: 'loadWords',
	    value: function loadWords() {
	      var _this = this;
	
	      this.showStartGameButton = false;
	      this.words = [];
	      this.learn = [];
	      this.wordsLoading = true;
	      this.Word.get({ rows: this.rows, cols: this.cols }).$promise.then(function (words) {
	        _this.words = words.words;
	        _this.learn = words.learn;
	        _this.showStartGameButton = true;
	      }).finally(function () {
	        _this.wordsLoading = false;
	      });
	    }
	  }, {
	    key: 'restartGame',
	    value: function restartGame() {
	      this.timer = 0;
	      this.timerPromise = null;
	      this.startGame = false;
	      this.gameOver = false;
	      this.visibleCards = [];
	      this.tempVisibleCards = [];
	      this.correctCards = [];
	      this.currentLevel = 0;
	      this.isResultSaved = false;
	      this.rows = this.levels[this.currentLevel][0];
	      this.cols = this.levels[this.currentLevel][1];
	
	      this.loadWords();
	    }
	  }, {
	    key: 'nextLevel',
	    value: function nextLevel() {
	      this.currentLevel += 1;
	      if (this.currentLevel > this.levels.length) {
	        return;
	      }
	      this.rows = this.levels[this.currentLevel][0];
	      this.cols = this.levels[this.currentLevel][1];
	      this.timerPromise = null;
	      this.startGame = false;
	      this.gameOver = false;
	      this.visibleCards = [];
	      this.tempVisibleCards = [];
	      this.correctCards = [];
	      this.loadWords();
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.startGame = true;
	      this.startCounting();
	    }
	  }, {
	    key: 'startCounting',
	    value: function startCounting() {
	      var _this2 = this;
	
	      this.timerPromise = this.$interval(function () {
	        _this2.timer += 1;
	      }, 10);
	    }
	  }, {
	    key: 'stopCounting',
	    value: function stopCounting() {
	      this.$interval.cancel(this.timerPromise);
	    }
	  }, {
	    key: 'checkIfVisible',
	    value: function checkIfVisible(index1, index2) {
	      return this.visibleCards.filter(function (item) {
	        return item[0] === index1 && item[1] === index2;
	      }).length;
	    }
	  }, {
	    key: 'checkIfCorrect',
	    value: function checkIfCorrect(index1, index2) {
	      return this.correctCards.filter(function (item) {
	        return item[0] === index1 && item[1] === index2;
	      }).length;
	    }
	  }, {
	    key: 'checkIfEnd',
	    value: function checkIfEnd() {
	      if (this.correctCards.length === this.rows * this.cols) {
	        this.stopCounting();
	        this.gameOver = true;
	        this.startGame = false;
	      }
	    }
	  }, {
	    key: 'showCard',
	    value: function showCard(index1, index2) {
	      if (this.canBeShow(index1, index2)) {
	        if (this.tempVisibleCards.length === 2) {
	          this.resetTempVisibleCards();
	        }
	        this.tempVisibleCards.push([index1, index2]);
	        this.visibleCards.push([index1, index2]);
	        if (this.tempVisibleCards.length === 2) {
	          this.checkTempVisibleCardsAreCorrect();
	          this.checkIfEnd();
	        }
	      }
	    }
	  }, {
	    key: 'canBeShow',
	    value: function canBeShow(index1, index2) {
	      return !this.checkIfCorrect(index1, index2);
	    }
	  }, {
	    key: 'checkTempVisibleCardsAreCorrect',
	    value: function checkTempVisibleCardsAreCorrect() {
	      var _this3 = this;
	
	      var index1_1 = this.tempVisibleCards[0][0];
	      var index1_2 = this.tempVisibleCards[0][1];
	      var index2_1 = this.tempVisibleCards[1][0];
	      var index2_2 = this.tempVisibleCards[1][1];
	      if (this.words[index1_1][index1_2].correct === this.words[index2_1][index2_2].correct) {
	        this.tempVisibleCards.forEach(function (item) {
	          _this3.correctCards.push(item);
	        });
	        this.resetTempVisibleCards();
	      }
	    }
	  }, {
	    key: 'resetTempVisibleCards',
	    value: function resetTempVisibleCards() {
	      var _this4 = this;
	
	      this.visibleCards = this.visibleCards.filter(function (item) {
	        return !_this4.tempVisibleCards.filter(function (tmp) {
	          return item[0] === tmp[0] && item[1] === tmp[1];
	        }).length;
	      });
	      this.tempVisibleCards = [];
	    }
	  }, {
	    key: 'saveResult',
	    value: function saveResult() {
	      var _this5 = this;
	
	      var gameResult = new this.GameResult();
	      gameResult.$save({ time: this.timer * 10 }).then(function (response) {
	        if (response) {
	          if (response.hash) {
	            _this5.ipCookie('jezor_game_result_hash', response.hash, {
	              path: '/'
	            });
	          }
	        }
	
	        if (!response.logged) {
	          document.location.href = webroot + 'logowanie';
	        } else {
	          _this5.isResultSaved = true;
	        }
	      });
	    }
	  }, {
	    key: 'play',
	    value: function play(id) {
	      document.getElementById('player_' + id).play();
	    }
	  }]);
	  return MemoController;
	}();
	
	exports.default = MemoController;

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Word = function Word($resource) {
	  'ngInject';
	
	  return $resource('http://jezor.pl/api/words/:rows/:cols');
	  // return $resource(`http://localhost/jezor/api/words/:rows/:cols`);
	};
	Word.$inject = ["$resource"];
	
	exports.default = Word;

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GameResult = function GameResult($resource) {
	  'ngInject';
	
	  return $resource('http://jezor.pl/api/save_game_result/:time');
	  // return $resource(`http://localhost/jezor/api/save_game_result/:time`);
	};
	GameResult.$inject = ["$resource"];
	
	exports.default = GameResult;

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(425);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(426);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E'
	};
	
	exports.default = appComponent;

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	module.exports = "<div ui-view></div>\n"

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(427);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(430)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(428)();
	// imports
	
	
	// module
	exports.push([module.id, ".card{margin:5px}.card,.card a,.card a:hover{display:block;width:140px;height:140px;float:left}.card a,.card a:hover{text-align:center;font-size:20px;text-decoration:none;border:1px solid #bbb;color:#000;cursor:pointer}.card a.cover{background:url(" + __webpack_require__(429) + ") no-repeat}.correct{background-color:#70c16d}.correct a,.correct a:hover{text-decoration:none;color:#fff}.summary{display:block;height:20px}.time,.unit{display:block;float:left;width:90px;margin:5px 0 0 50px}.unit{margin-left:0}", ""]);
	
	// exports


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "bg_card_cover.png";

/***/ })

});


// WEBPACK FOOTER //
// app.bundle.js